import { useI18n } from "@/lib/i18n";

export function Vision() {
  const { t } = useI18n();
  return (
    <section className="relative -mt-10 overflow-hidden bg-background px-6 pt-16 pb-24">
      <div className="absolute inset-0 bg-grid opacity-[0.18] pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-background to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-background to-transparent pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full bg-primary/5 blur-[160px] pointer-events-none" />
      <div className="relative max-w-4xl mx-auto text-center">
        <span className="inline-block text-xs uppercase tracking-[0.25em] text-primary font-semibold mb-5">
          {t("vision.eyebrow")}
        </span>
        <h2 className="text-4xl md:text-6xl font-bold tracking-tight leading-[1.1] mb-8">
          {t("vision.title.1")}
          <span className="block text-gradient-orange whitespace-nowrap my-2">{t("vision.title.2")}</span>
          <span className="text-gradient-orange">{t("vision.title.3")}</span>
        </h2>
        <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
          {t("vision.body")}
          {t("vision.grow") && <span className="block text-center mt-2">{t("vision.grow")}</span>}
          {t("vision.allInOne") && <span className="block text-xl font-bold uppercase tracking-wider text-white text-center mt-2">{t("vision.allInOne")}</span>}
        </p>
      </div>
    </section>
  );
}
